<template>
  <div class="wrapperlogin">
    <div class="loginav">
      <div class="video">
        <video src="./images/video.mp4" muted autoplay loop />
      </div>
      <div class=""></div>
      <div class="loginbox boxall">
        <div class="logo">
          <h1>CRM后台管理系统</h1>
          <!-- <h2>zhi neng ke ji ping tai</h2> -->
          <!-- <img src="images/logo.png"> -->
        </div>
        <div class="logintit">平台管理员登录</div>
        <ul class="logininput">
          <li>
            <i><img src="./images/user.png" /></i>
            <input class="forminput" v-model="formData.account" type="text" placeholder="用户名" />
          </li>
          <li>
            <i><img src="./images/password.png" /></i>
            <input class="forminput" type="password" v-model="formData.password" placeholder="密码" />
          </li>

          <!-- <div class="flex1" style="padding: 15px 0">
            <label> <input type="checkbox" checked class="aui-checkbox" />&nbsp;记住密码</label>
            <a href="index.html#" class="text-primary"> 忘记密码？</a>
          </div> -->
          <li>
            <a href="javascript:;" class="btn btnblock btn-lg btn-block btn-primary" @click.prevent="onSubmit">登录</a>
          </li>
        </ul>
        <div class="boxfoot"></div>
      </div>
    </div>

    <canvas id="canvas" style="position: fixed; width: 100%; height: 100%; left: 0; top: 0; opacity: 0.3; pointer-events: none"></canvas>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      imgCode: '',
      formData: {
        account: '',
        password: ''
      },
      rules: {}
    }
  },

  mounted() {

  },

  methods: {
    onSubmit() {
      this.$store.dispatch('Login', this.formData).then(() => {
        this.$router.push({ path: '/agent/list' })
        sessionStorage.removeItem('keyPath')
        this.$store.dispatch('tagsView/delAllViews')
      })
    }
  }
}
</script>

<style lang="css" scoped>
@import './css/style.css';
.wrapperlogin {
  height: 100vh;
}
</style>
